export const navigation = (
  <path
    d="M14.7227 1.45044L1.62305 6.55539L6.97783 8.86928L9.16933 14.3019L14.7227 1.45044Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
export default navigation;
